import React, { Component } from 'react';

export const GlobalDataContext = React.createContext('globalDataContext');

class GlobalData extends Component {
  state = {
    token: localStorage.getItem('userInventoryToken'),
    user: null,
  };

  componentDidMount = () => {
    if (localStorage.getItem('userInventory')) {
      const user = JSON.parse(localStorage.getItem('userInventory'));
      this.setState({ user });
    }
  };

  render() {
    const { children } = this.props;
    const { token, user } = this.state;
    return (
      <GlobalDataContext.Provider value={{ token, user }}>{children}</GlobalDataContext.Provider>
    );
  }
}

export default GlobalData;
